import styled from "styled-components";

export interface EquipStatusItemStyleProps {
  $pLeft?: any;
  $pTop?: any;
  $pRight?: any;
  $pBottom?: any;
  $path?: string;
  $power?: boolean;
  $status?: "normal" | "warning" | "critical" | "off";
}

export const EquipStatusItem = styled.li<EquipStatusItemStyleProps>`
  position: absolute;
  display: flex;
  top: ${(props) => props.$pTop};
  left: ${(props) => props.$pLeft};
  right: ${(props) => props.$pRight};
  bottom: ${(props) => props.$pBottom};
  align-items: flex-end;
  flex-direction: column;
  gap: 4px;
  cursor: ${(props) => props.$path && "pointer"};
`;

export const EquipStatusPower = styled.div<EquipStatusItemStyleProps>`
  display: flex;
  width: 32px;
  height: 20px;
  /* color: ${(props) =>
    props.$power === true
      ? props.theme.colors.primary100
      : props.theme.colors.black12}; */
  color: ${(props) =>
    props.$power === true
      ? props.theme.colors.white100
      : props.theme.colors.black12};
  font-size: 1.2rem;
  font-weight: 500;
  /* background: ${(props) => props.theme.colors.white100}; */
  background: ${(props) =>
    props.$power === true
      ? props.theme.colors.primary100
      : props.theme.colors.white100};
  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.$power === true
        ? props.theme.colors.primary100
        : props.theme.colors.black12};
  align-items: center;
  justify-content: center;
`;

export const EquipStatusBox = styled.div<EquipStatusItemStyleProps>`
  display: flex;
  height: 28px;
  padding: 10px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.2rem;
  font-weight: 700;
  background: ${(props) =>
    props.$status === "normal"
      ? props.theme.colors.greenStatus
      : props.$status === "warning"
      ? props.theme.colors.yellowStatus
      : props.$status === "critical"
      ? props.theme.colors.redStatus
      : props.theme.colors.gray100};
  border-radius: 6px;
  align-items: center;
  justify-content: center;
`;
